(function() {
  exports.Product = (function() {
    function Product() {
      this.id = null;
      this.seed_companies_id = null;
      this.name = '';
      this.trait_packages_id = null;
      this.active = null;
      this.is_placeable = null;
      this.treatment_options = [];
      this.full_name = '';
    }

    return Product;

  })();

}).call(this);
